import React from 'react';
import {
  Row, Col, Typography, Form, Select,
  InputNumber, Checkbox, Input,
} from 'antd';
import CurrencyInput from 'react-currency-input';
import PropTypes from 'prop-types';
import './DetailsFields.scss';
import { getUserType } from '../../../../../utils/users';

const Details = (props) => {
  const {
    formInstance, initialValuesObject, mode, edit, detail,
  } = props;

  const depthsOptions = [
    '1',
    '2',
    '3',
    '4',
    '5',
  ];

  const options = [
    '0-5', '0-10', '0-15',
    '0-20', '0-25', '0-30',
    '0-40', '0-50', '5-10',
    '5-20', '10-15', '10-20',
    '15-20', '15-30', '20-30',
    '20-40', '25-50', '30-40',
    '30-45', '30-60', '40-60',
    '40-80', '45-60', '50-70',
    '50-75', '50-80', '50-100',
    '60-80', '60-90', '75-100',
    '80-100',
  ];

  const porcOptions = [
    '10%', '20%', '30%',
    '40%', '50%', '60%',
    '70%', '80%', '90%',
    '100%',
  ];

  const handleBrokenBoolean = (brokenValue) => {
    switch (true) {
      case (brokenValue === 'true'):
      case (brokenValue === true):
        return true;

      case (brokenValue === 'false'):
      case (brokenValue === false):
      default:
        return false;
    }
  };

  const validateProfundidade = (field) => {
    const id = field.field.slice(-1)[0];
    const rotina = formInstance.getFieldValue(`GEOFERT-GRID-ROTINA_ALUMINIO_ENXOFRE_PROFUNDIDADE_${id}`);
    const micro = formInstance.getFieldValue(`GEOFERT-GRID-MICRO_PROFUNDIDADE_${id}`);
    const fisica = formInstance.getFieldValue(`GEOFERT-GRID-FISICA_PROFUNDIDADE_${id}`);

    if (!rotina && !micro && !fisica) {
      if (field.field.includes('GEOFERT-GRID-FISICA_PROFUNDIDADE')) {
        return Promise.reject(new Error('Pelo menos um dos campos de amostragem na camada deve estar selecionado'));
      }

      return Promise.reject(new Error(''));
    }
    return Promise.resolve();
  };

  const validateCms = (field) => {
    const id = Number(field.field.slice(-1)[0]);
    const actual = formInstance.getFieldValue(`GEOFERT-GRID-PROFUNDIDADE_${id}`);
    let ind = 1;

    while (ind < id) {
      const conditionValue = formInstance.getFieldValue(`GEOFERT-GRID-PROFUNDIDADE_${ind}`);
      if (actual != null) {
        if (conditionValue != null) {
          if (Number(actual.split('-')[0]) < Number(conditionValue.split('-')[1])) {
            return Promise.reject(new Error('As camadas não podem ser sobrepostas'));
          }
        }
      }
      ind++;
    }

    return Promise.resolve();
  };

  const validateRange = (rule, value, min, max, localComparison) => {
    if (localComparison === 'GREATER') {
      if (max != null && parseInt(value, 10) > parseInt(max, 10)) {
        if (min) {
          return Promise.reject(new Error(`Por favor, insira um valor entre ${min} e ${max}`));
        }
        return Promise.reject(new Error(`Por favor, insira um valor menor que ${max}`));
      }

      if (min != null && parseInt(value, 10) <= parseInt(min, 10)) {
        if (max != null) {
          return Promise.reject(new Error(`Por favor, insira um valor entre ${min} e ${max}`));
        }
        return Promise.reject(new Error(`Por favor, insira um valor maior que ${min}`));
      }
      return Promise.resolve();
    }

    if (max != null && parseInt(value, 10) > parseInt(max, 10)) {
      if (min) {
        return Promise.reject(new Error(`Por favor, insira um valor entre ${min} e ${max}`));
      }
      return Promise.reject(new Error(`Por favor, insira um valor menor que ${max}`));
    }

    if (min != null && parseInt(value, 10) < parseInt(min, 10)) {
      if (max != null) {
        return Promise.reject(new Error(`Por favor, insira um valor entre ${min} e ${max}`));
      }
      return Promise.reject(new Error(`Por favor, insira um valor maior que ${min}`));
    }
    return Promise.resolve();
  };

  return (
    <>
      <Row
        gutter={[24, 24]}
        className="GridDetails__GridSizeRow"
      >
        <Col
          xs={{ span: 24 }}
          className="GridDetails__GridSizeColumn"
        >
          <Form.Item
            label={(
              <Typography.Title
                level={5}
                className="GridDetails__GridSizeTitle GridDetails__AllFormLabels"
              >
                Tamanho do grid (em hectares)
              </Typography.Title>
            )}
            name="GEOFERT-GRID-TAMANHO_GRID"
            className="GridDetails__GridSizeFormItem"
            rules={[
              {
                required: true,
                message: 'O campo é obrigatório',
              },
            ]}
            initialValue={initialValuesObject?.['GEOFERT-GRID-TAMANHO_GRID']}
          >
            <Select
              className="GridDetails__GridSizeSelect"
              disabled={edit}
            >
              {
                [
                  '0.5',
                  '1',
                  '1.5',
                  '2',
                  '2.5',
                  '3',
                  '5',
                  '10',
                  '20',
                  '25',
                  'Outro',
                ].map((v) => (
                  <Select.Option
                    key={v}
                    value={v}
                    className="GridDetails__GridSizeSelectOption"
                  >
                    {v}
                  </Select.Option>
                ))
              }
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Form.Item
        className="GridDetails__DesiredSizeParentFormItem"
        noStyle
        shouldUpdate={
          (previousValues, currentValues) => {
            return currentValues['GEOFERT-GRID-TAMANHO_GRID']
              !== previousValues['GEOFERT-GRID-TAMANHO_GRID'];
          }
        }
      >
        {
          (formInstanceParameter) => {
            if (
              formInstanceParameter
                .getFieldValue('GEOFERT-GRID-TAMANHO_GRID')
              === 'Outro'
            ) {
              return (
                <Row
                  gutter={[24, 24]}
                  className="GridDetails__DesiredSizeRow"
                >
                  <Col
                    xs={{ span: 24 }}
                    className="GridDetails__DesiredSizeColumn"
                  >
                    <Form.Item
                      className="GridDetails__DesiredSizeFormItem"
                      label={(
                        <Typography.Title
                          level={5}
                          className="GridDetails__DesiredSizeTitle GridDetails__AllFormLabels"
                        >
                          Tamanho desejado
                        </Typography.Title>
                      )}
                      name="GEOFERT-GRID-GRID_TAMANHO_DESEJADO"
                      rules={[
                        {
                          type: 'number',
                        },
                        {
                          required: true,
                          message: 'O campo é obrigatório',
                        },
                        {
                          validator: (a, b) => {
                            return validateRange(a, b, 0, null, 'GREATER');
                          },
                        },
                      ]}
                      initialValue={initialValuesObject?.['GEOFERT-GRID-GRID_TAMANHO_DESEJADO']}
                    >
                      <InputNumber
                        style={{ width: '100%' }}
                        min={0}
                        disabled={edit}
                        className="GridDetails__DesiredSizeInputNumber"
                      />
                    </Form.Item>
                  </Col>
                </Row>
              );
            }

            return null;
          }
        }
      </Form.Item>

      <Row
        gutter={[24, 24]}
        className="GridDetails__VDesejadoRow"
      >
        <Col
          xs={{ span: 24 }}
          className="GridDetails__VDesejadoColumn"
        >
          <Form.Item
            className="GridDetails__VDesejadoFormItem"
            label={(
              <Typography.Title
                level={5}
                className="GridDetails__VDesejadoTitle GridDetails__AllFormLabels"
              >
                V% desejado
              </Typography.Title>
            )}
            name="GEOFERT-GRID-V_DESEJADO"
            rules={[]}
            initialValue={initialValuesObject?.['GEOFERT-GRID-V_DESEJADO']}
          >
            <InputNumber
              style={{ width: '100%' }}
              min={0}
              max={100}
              disabled={edit}
              className="GridDetails__VDesejadoInputNumber"
            />
          </Form.Item>
        </Col>
      </Row>

      <Row
        gutter={[24, 24]}
        className="GridDetails__PRNTCalcarioRow"
      >
        <Col
          xs={{ span: 24 }}
          className="GridDetails__PRNTCalcarioColumn"
        >
          <Form.Item
            className="GridDetails__PRNTCalcarioFormItem"
            label={(
              <Typography.Title
                level={5}
                className="GridDetails__PRNTCalcarioTitle GridDetails__AllFormLabels"
              >
                PRNT do calcário
              </Typography.Title>
            )}
            name="GEOFERT-GRID-PRNT_CALCARIO"
            rules={[]}
            initialValue={initialValuesObject?.['GEOFERT-GRID-PRNT_CALCARIO']}
          >
            <InputNumber
              style={{ width: '100%' }}
              min={0}
              max={100}
              disabled={edit}
              className="GridDetails__PRNTCalcarioInputNumber"
            />
          </Form.Item>
        </Col>
      </Row>

      <Row
        gutter={[24, 24]}
        className="GridDetails__PRNTOxidoRow"
      >
        <Col
          xs={{ span: 24 }}
          className="GridDetails__PRNTOxidoColumn"
        >
          <Form.Item
            className="GridDetails__PRNTOxidoFormItem"
            label={(
              <Typography.Title
                level={5}
                className="GridDetails__PRNTOxidoTitle GridDetails__AllFormLabels"
              >
                PRNT do óxido
              </Typography.Title>
            )}
            name="GEOFERT-GRID-PRNT_OXIDO"
            rules={[]}
            initialValue={initialValuesObject?.['GEOFERT-GRID-PRNT_OXIDO']}
          >
            <InputNumber
              style={{ width: '100%' }}
              min={130}
              max={180}
              disabled={edit}
              className="GridDetails__PRNTOxidoInputNumber"
            />
          </Form.Item>
        </Col>
      </Row>

      <Row
        gutter={24}
        key="GEOFERT-GRID-QUANTAS_PROFUNDIDADES"
        className="inline-field"
      >
        <Col span={24}>
          <Form.Item
            label={(
              <span
                className="GridDetails__PRNTCalcarioTitle GridDetails__AllFormLabels"
              >
                Quantas profundidades?
              </span>
            )}
            name="GEOFERT-GRID-QUANTAS_PROFUNDIDADES"
            rules={[{ required: true, message: 'O campo é obrigatório' }]}
            initialValue={initialValuesObject?.['GEOFERT-GRID-QUANTAS_PROFUNDIDADES']}
          >
            <Select
              disabled={mode === 'EDIT'}
            >
              {
                depthsOptions.map((v) => (
                  <Select.Option key={v} value={v}>
                    {v}
                  </Select.Option>
                ))
              }
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Form.Item
        noStyle
        shouldUpdate={
          (previousValues, currentValues) => {
            return previousValues['GEOFERT-GRID-QUANTAS_PROFUNDIDADES']
              !== currentValues['GEOFERT-GRID-QUANTAS_PROFUNDIDADES'];
          }
        }
      >
        {
          (formInstanceParameter) => {
            let conditionalRendering;
            const qtdProfund = formInstanceParameter.getFieldValue('GEOFERT-GRID-QUANTAS_PROFUNDIDADES');

            if (qtdProfund != undefined && Number.parseInt(qtdProfund, 10) > 0) {
              conditionalRendering = Array(
                Number.parseInt(qtdProfund, 10),
              )
                .fill('', 0, 9)
                .map((arrayValue, i) => {
                  return (
                    <>
                      <Row
                        gutter={24}
                        key={`GEOFERT-GRID-PROFUNDIDADE_${Number(i + 1)}`}
                        className="inline-field"
                      >
                        <Col span={24}>
                          <Form.Item
                            label={(
                              <span
                                className="GridDetails__PRNTCalcarioTitle GridDetails__AllFormLabels"
                              >
                                {`Profundidade ${Number(i + 1)}`}
                              </span>
                            )}
                            name={`GEOFERT-GRID-PROFUNDIDADE_${Number(i + 1)}`}
                            rules={[
                              {
                                required: true,
                                message: 'O campo é obrigatório',
                              },
                              {
                                validator: validateCms,
                              },
                            ]}
                            initialValue={initialValuesObject?.[`GEOFERT-GRID-PROFUNDIDADE_${Number(i + 1)}`]}
                          >
                            <Select disabled={edit}>
                              {i != 0 ? (
                                options.map((_v) => (
                                  <Select.Option key={_v} value={_v}>
                                    {_v}
                                  </Select.Option>
                                ))
                              ) : (
                                options.filter((f) => f.split('-')[0] == '0').map((_v) => (
                                  <Select.Option key={_v} value={_v}>
                                    {_v}
                                  </Select.Option>
                                ))
                              )
                              }
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row
                        gutter={24}
                        key={`GEOFERT-GRID-ROTINA_ALUMINIO_ENXOFRE_PROFUNDIDADE_${Number(i + 1)}`}
                        className="inline-field"
                      >
                        <Col span={24}>
                          <Form.Item
                            valuePropName="checked"
                            name={`GEOFERT-GRID-ROTINA_ALUMINIO_ENXOFRE_PROFUNDIDADE_${Number(i + 1)}`}
                            rules={[
                              {
                                validator: validateProfundidade,
                              },
                            ]}
                            initialValue={
                              (initialValuesObject && `GEOFERT-GRID-ROTINA_ALUMINIO_ENXOFRE_PROFUNDIDADE_${Number(i + 1)}` in initialValuesObject)
                                ? handleBrokenBoolean(
                                  initialValuesObject?.[`GEOFERT-GRID-ROTINA_ALUMINIO_ENXOFRE_PROFUNDIDADE_${Number(i + 1)}`],
                                )
                                : false
                            }
                          >
                            <Checkbox
                              disabled={edit}
                              onChange={() => {
                                formInstance.validateFields([
                                  `GEOFERT-GRID-MICRO_PROFUNDIDADE_${Number(i + 1)}`,
                                  `GEOFERT-GRID-FISICA_PROFUNDIDADE_${Number(i + 1)}`,
                                ]);
                              }}
                              className="field-sub-title-text GridDetails__AllFormLabels"
                            >
                              Rotina Alumínio e enxofre
                            </Checkbox>
                          </Form.Item>
                        </Col>
                      </Row>

                      <Form.Item
                        noStyle
                        shouldUpdate={
                          (previousValues, currentValues) => {
                            return previousValues[`GEOFERT-GRID-ROTINA_ALUMINIO_ENXOFRE_PROFUNDIDADE_${Number(i + 1)}`]
                              !== currentValues[`GEOFERT-GRID-ROTINA_ALUMINIO_ENXOFRE_PROFUNDIDADE_${Number(i + 1)}`];
                          }
                        }
                      >
                        {
                          (formInstanceParameter2) => {
                            if (
                              formInstanceParameter2
                                .getFieldValue(
                                  `GEOFERT-GRID-ROTINA_ALUMINIO_ENXOFRE_PROFUNDIDADE_${Number(i + 1)}`,
                                ) === true
                            ) {
                              return (
                                <Row gutter={24} className="inline-field">
                                  <Col span={24}>
                                    <Form.Item
                                      name={`GEOFERT-GRID-PROPORCAO_PROFUNDIDADE_${Number(i + 1)}_ROTINA_ALUMINIO_ENXOFRE`}
                                      rules={[
                                        {
                                          required: true,
                                          message: 'O campo é obrigatório',
                                        },
                                      ]}
                                      label={(
                                        <span
                                          className="GridDetails__PRNTCalcarioTitle GridDetails__AllFormLabels"
                                        >
                                          Proporção
                                        </span>
                                      )}
                                      initialValue={initialValuesObject?.[`GEOFERT-GRID-PROPORCAO_PROFUNDIDADE_${Number(i + 1)}_ROTINA_ALUMINIO_ENXOFRE`] || undefined}
                                    >
                                      <Select disabled={edit} className="GridDetails__GridSizeSelect">
                                        {
                                          porcOptions.map((_op) => (
                                            <Select.Option key={_op} value={_op}>
                                              {_op}
                                            </Select.Option>
                                          ))
                                        }
                                      </Select>
                                    </Form.Item>
                                  </Col>
                                </Row>
                              );
                            }

                            return null;
                          }
                        }
                      </Form.Item>

                      <Row
                        gutter={24}
                        key={`GEOFERT-GRID-MICRO_PROFUNDIDADE_${Number(i + 1)}`}
                        className="inline-field"
                      >
                        <Col span={24}>
                          <Form.Item
                            valuePropName="checked"
                            name={`GEOFERT-GRID-MICRO_PROFUNDIDADE_${Number(i + 1)}`}
                            rules={[
                              {
                                validator: validateProfundidade,
                              },
                            ]}
                            initialValue={
                              (initialValuesObject && `GEOFERT-GRID-MICRO_PROFUNDIDADE_${Number(i + 1)}` in initialValuesObject)
                                ? handleBrokenBoolean(
                                  initialValuesObject?.[`GEOFERT-GRID-MICRO_PROFUNDIDADE_${Number(i + 1)}`],
                                )
                                : false
                            }
                          >
                            <Checkbox
                              disabled={edit}
                              onChange={() => {
                                formInstance.validateFields([
                                  `GEOFERT-GRID-ROTINA_ALUMINIO_ENXOFRE_PROFUNDIDADE_${Number(i + 1)}`,
                                  `GEOFERT-GRID-FISICA_PROFUNDIDADE_${Number(i + 1)}`,
                                ]);
                              }}
                              className="field-sub-title-text GridDetails__AllFormLabels"
                            >
                              Micro
                            </Checkbox>
                          </Form.Item>
                        </Col>
                      </Row>

                      <Form.Item
                        noStyle
                        shouldUpdate={
                          (previousValues, currentValues) => {
                            return previousValues[`GEOFERT-GRID-MICRO_PROFUNDIDADE_${Number(i + 1)}`]
                              !== currentValues[`GEOFERT-GRID-MICRO_PROFUNDIDADE_${Number(i + 1)}`];
                          }
                        }
                      >
                        {
                          (formInstanceParameter3) => {
                            if (
                              formInstanceParameter3
                                .getFieldValue(
                                  `GEOFERT-GRID-MICRO_PROFUNDIDADE_${Number(i + 1)}`,
                                ) === true
                            ) {
                              return (
                                <Row
                                  gutter={24}
                                  className="inline-field"
                                >
                                  <Col span={24}>
                                    <Form.Item
                                      name={`GEOFERT-GRID-PROPORCAO_PROFUNDIDADE_${Number(i + 1)}_MICRO`}
                                      rules={[
                                        {
                                          required: true,
                                          message: 'O campo é obrigatório',
                                        },
                                      ]}
                                      label={(
                                        <span
                                          className="GridDetails__PRNTCalcarioTitle GridDetails__AllFormLabels"
                                        >
                                          Proporção
                                        </span>
                                      )}
                                      initialValue={initialValuesObject?.[`GEOFERT-GRID-PROPORCAO_PROFUNDIDADE_${Number(i + 1)}_MICRO`] || undefined}
                                    >
                                      <Select disabled={edit} className="GridDetails__GridSizeSelect">
                                        {
                                          porcOptions.map((_op) => (
                                            <Select.Option key={_op} value={_op}>
                                              {_op}
                                            </Select.Option>
                                          ))
                                        }
                                      </Select>
                                    </Form.Item>
                                  </Col>
                                </Row>
                              );
                            }

                            return null;
                          }
                        }
                      </Form.Item>

                      <Row
                        gutter={24}
                        key={`GEOFERT-GRID-FISICA_PROFUNDIDADE_${Number(i + 1)}`}
                        className="inline-field"
                      >
                        <Col span={24}>
                          <Form.Item
                            valuePropName="checked"
                            name={`GEOFERT-GRID-FISICA_PROFUNDIDADE_${Number(i + 1)}`}
                            rules={[
                              {
                                validator: validateProfundidade,
                              },
                            ]}
                            initialValue={
                              (initialValuesObject && `GEOFERT-GRID-FISICA_PROFUNDIDADE_${Number(i + 1)}` in initialValuesObject)
                                ? handleBrokenBoolean(
                                  initialValuesObject?.[`GEOFERT-GRID-FISICA_PROFUNDIDADE_${Number(i + 1)}`],
                                )
                                : false
                            }
                          >
                            <Checkbox
                              disabled={edit}
                              onChange={() => {
                                formInstance.validateFields([
                                  `GEOFERT-GRID-MICRO_PROFUNDIDADE_${Number(i + 1)}`,
                                  `GEOFERT-GRID-ROTINA_ALUMINIO_ENXOFRE_PROFUNDIDADE_${Number(i + 1)}`,
                                ]);
                              }}
                              className="field-sub-title-text GridDetails__AllFormLabels"
                            >
                              Física
                            </Checkbox>
                          </Form.Item>
                        </Col>
                      </Row>

                      <Form.Item
                        noStyle
                        shouldUpdate={
                          (previousValues, currentValues) => {
                            return previousValues[`GEOFERT-GRID-FISICA_PROFUNDIDADE_${Number(i + 1)}`]
                              !== currentValues[`GEOFERT-GRID-FISICA_PROFUNDIDADE_${Number(i + 1)}`];
                          }
                        }
                      >
                        {
                          (formInstanceParameter4) => {
                            if (
                              formInstanceParameter4
                                .getFieldValue(
                                  `GEOFERT-GRID-FISICA_PROFUNDIDADE_${Number(i + 1)}`,
                                ) === true
                            ) {
                              return (
                                <Row
                                  gutter={24}
                                  className="inline-field"
                                >
                                  <Col span={24}>
                                    <Form.Item
                                      name={`GEOFERT-GRID-PROPORCAO_PRODUNDIDADE_${Number(i + 1)}_FISICA`}
                                      rules={[
                                        {
                                          required: true,
                                          message: 'O campo é obrigatório',
                                        },
                                      ]}
                                      label={(
                                        <span
                                          className="GridDetails__PRNTCalcarioTitle GridDetails__AllFormLabels"
                                        >
                                          Proporção
                                        </span>
                                      )}
                                      initialValue={initialValuesObject?.[`GEOFERT-GRID-PROPORCAO_PRODUNDIDADE_${Number(i + 1)}_FISICA`] || undefined}
                                    >
                                      <Select disabled={edit} className="GridDetails__GridSizeSelect">
                                        {
                                          porcOptions.map((_op) => (
                                            <Select.Option key={_op} value={_op}>
                                              {_op}
                                            </Select.Option>
                                          ))
                                        }
                                      </Select>
                                    </Form.Item>
                                  </Col>
                                </Row>
                              );
                            }

                            return null;
                          }
                        }
                      </Form.Item>
                    </>
                  );
                });
            }

            return conditionalRendering;
          }
        }
      </Form.Item>

      {
        getUserType() === 'COOPERCITRUS' && !detail
        && (
          <>
            <Row gutter={[24, 24]}>
              <Col xs={{ span: 24 }}>
                <hr />
                <p className="GridDetails__SessionTitle">Orçamento</p>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="GridDetails__DesiredSizeRow"
            >
              <Col
                xs={{ span: 24 }}
                className="GridDetails__DesiredSizeColumn"
              >
                <Form.Item
                  className="GridDetails__DesiredSizeFormItem"
                  label={(
                    <Typography.Title
                      level={5}
                      className="GridDetails__DesiredSizeTitle GridDetails__AllFormLabels"
                    >
                      Valor unitário
                    </Typography.Title>
                  )}
                  name="GEOFERT-GRID-VALOR_UNITARIO"
                  rules={[
                    {
                      validator: (rule, value) => {
                        if (value < 0) {
                          return Promise.reject(new Error('Deve ser um numero maior que zero'));
                        }

                        return Promise.resolve();
                      },
                    },
                  ]}
                  initialValue={
                    (
                      initialValuesObject?.['GEOFERT-GRID-VALOR_UNITARIO']
                        ? initialValuesObject['GEOFERT-GRID-VALOR_UNITARIO'].replaceAll('.', ',')
                        : '0,00'
                    )
                  }
                >
                  <CurrencyInput
                    allowEmpty="true"
                    className="ant-input"
                    decimalSeparator=","
                    thousandSeparator="."
                    placeholder="0,00"
                    step={0.01}
                    min={0}
                    disabled={edit}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="GridDetails__DesiredSizeRow"
            >
              <Col
                xs={{ span: 24 }}
                className="GridDetails__DesiredSizeColumn"
              >
                <Form.Item
                  className="GridDetails__DesiredSizeFormItem"
                  label={(
                    <Typography.Title
                      level={5}
                      className="GridDetails__DesiredSizeTitle GridDetails__AllFormLabels"
                    >
                      Valor total
                    </Typography.Title>
                  )}
                  name="GEOFERT-GRID-VALOR_TOTAL"
                  rules={[
                    {
                      validator: (rule, value) => {
                        if (value < 0) {
                          return Promise.reject(new Error('Deve ser um numero maior que zero'));
                        }

                        return Promise.resolve();
                      },
                    },
                  ]}
                  initialValue={
                    (
                      initialValuesObject?.['GEOFERT-GRID-VALOR_TOTAL']
                        ? initialValuesObject['GEOFERT-GRID-VALOR_TOTAL'].replaceAll('.', ',')
                        : '0,00'
                    )
                  }
                >
                  <CurrencyInput
                    allowEmpty="true"
                    className="ant-input"
                    decimalSeparator=","
                    thousandSeparator="."
                    placeholder="0,00"
                    step={0.01}
                    min={0}
                    disabled={edit}
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="GridDetails__DesiredSizeRow"
            >
              <Col
                xs={{ span: 24 }}
                className="GridDetails__DesiredSizeColumn"
              >
                <Form.Item
                  className="GridDetails__DesiredSizeFormItem"
                  label={(
                    <Typography.Title
                      level={5}
                      className="GridDetails__DesiredSizeTitle GridDetails__AllFormLabels"
                    >
                      Condição de pagamento
                    </Typography.Title>
                  )}
                  name="GEOFERT-GRID-CONDICAO_PAGAMENTO"
                  rules={[
                    { max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' },
                  ]}
                  initialValue={initialValuesObject?.['GEOFERT-GRID-CONDICAO_PAGAMENTO']}
                >
                  <Input
                    style={{ width: '100%' }}
                    disabled={edit}
                    maxLength="255"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="GridDetails__DesiredSizeRow"
            >
              <Col
                xs={{ span: 24 }}
                className="GridDetails__DesiredSizeColumn"
              >
                <Form.Item
                  className="GridDetails__DesiredSizeFormItem"
                  label={(
                    <Typography.Title
                      level={5}
                      className="GridDetails__DesiredSizeTitle GridDetails__AllFormLabels"
                    >
                      Forma de pagamento
                    </Typography.Title>
                  )}
                  name="GEOFERT-GRID-FORMA_PAGAMENTO"
                  rules={[
                    { max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' },
                  ]}
                  initialValue={initialValuesObject?.['GEOFERT-GRID-FORMA_PAGAMENTO']}
                >
                  <Input
                    style={{ width: '100%' }}
                    disabled={edit}
                    maxLength="255"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={[24, 24]}
              className="GridDetails__DesiredSizeRow"
            >
              <Col
                xs={{ span: 24 }}
                className="GridDetails__DesiredSizeColumn"
              >
                <Form.Item
                  className="GridDetails__DesiredSizeFormItem"
                  label={(
                    <Typography.Title
                      level={5}
                      className="GridDetails__DesiredSizeTitle GridDetails__AllFormLabels"
                    >
                      Observações do orçamento
                    </Typography.Title>
                  )}
                  name="GEOFERT-GRID-OBSERVACOES"
                  rules={[
                    { max: 255, message: 'O tamanho maximo do campo é de 255 caracteres' },
                  ]}
                  initialValue={initialValuesObject?.['GEOFERT-GRID-OBSERVACOES']}
                >
                  <Input
                    style={{ width: '100%' }}
                    disabled={edit}
                    maxLength="255"
                  />
                </Form.Item>
              </Col>
            </Row>
          </>
        )
      }

    </>
  );
};

Details.propTypes = {
  formInstance: PropTypes.shape({
    getFieldValue: PropTypes.func.isRequired,
    validateFields: PropTypes.func.isRequired,
  }).isRequired,

  mode: PropTypes.oneOf(['CREATE', 'EDIT']).isRequired,

  initialValuesObject: PropTypes.shape({
    'GEOFERT-GRID-QUANTAS_PROFUNDIDADES': PropTypes.oneOf([undefined, '1', '2', '3', '4', '5']),
    'GEOFERT-GRID-TAMANHO_GRID': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-GRID-GRID_TAMANHO_DESEJADO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-GRID-V_DESEJADO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-GRID-PRNT_CALCARIO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-GRID-PRNT_OXIDO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-GRID-VALOR_UNITARIO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-GRID-VALOR_TOTAL': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-GRID-CONDICAO_PAGAMENTO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-GRID-FORMA_PAGAMENTO': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'GEOFERT-GRID-OBSERVACOES': PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  edit: PropTypes.bool,
  detail: PropTypes.bool,
};
Details.defaultProps = {
  detail: false,
};

export default Details;
